import { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import { SearchableCombobox, TSearchable } from '../base/combobox'
import { MystroTestsQuery } from './__generated__/selector_query'
import { Query } from './selector_query'
import { dedupe } from '@/helpers/dedupe'
import { useCombobox } from '@/helpers/useCombobox'

type MystroTest = MystroTestsQuery['mystroTests'][0]

interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}

export const Selector = ({ value, onChange, invalid }: Props) => {
  const { data, loading } = useQuery<MystroTestsQuery>(Query)

  const { items: mystroTests } = useCombobox<MystroTest>({
    pageInfo: undefined,
    querySelected: undefined,
    queryCollection: data?.mystroTests,
    buildSearchable: item => ({
      id: item.id,
      name: item.name,
    })
  })

  const [items, setItems] = useState<TSearchable[]>([])

  useEffect(() => {
    if (!data) return

    setItems(
      dedupe([...mystroTests]).sort((a, b) => ('' + a.name).localeCompare(b.name))
    )
  }, [data, mystroTests])

  return (
    <SearchableCombobox
      data={items}
      fetchMore={() => {}}
      includeBlank={false}
      invalid={invalid}
      loading={loading}
      moreToFetch={false}
      placeholder="What's the test?"
      refetch={() => {}}
      searchField=""
      value={items.find(i => i.id == value) || { id: '', name: '' }}
      onChange={onChange}
    />
  )
}
